var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.464 24.7696C13.3607 24.7696 12.2675 24.4457 11.4072 23.8081L7.05475 20.5589C5.90085 19.6986 5 17.8969 5 16.4697V8.93902C5 7.38025 6.14377 5.72026 7.61145 5.17368L12.6623 3.28088C13.6644 2.90637 15.2434 2.90637 16.2454 3.28088L21.2963 5.17368C22.7639 5.72026 23.9077 7.38025 23.9077 8.93902V16.4596C23.9077 17.8969 23.0069 19.6884 21.853 20.5488L17.5006 23.7979C16.6604 24.4457 15.5673 24.7696 14.464 24.7696ZM13.1987 4.70807L8.14791 6.60087C7.28755 6.92477 6.52841 8.01793 6.52841 8.94915V16.4697C6.52841 17.4313 7.20657 18.7775 7.96572 19.3443L12.3181 22.5934C13.4822 23.4639 15.4458 23.4639 16.6199 22.5934L20.9724 19.3443C21.7416 18.7673 22.4097 17.4313 22.4097 16.4697V8.93902C22.4097 8.01793 21.6505 6.92477 20.7902 6.59074L15.7393 4.69795C15.0511 4.45502 13.8769 4.45502 13.1987 4.70807Z",
    fill: "url(#paint0_linear_2256_121387)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1074 16.1357C12.9151 16.1357 12.7228 16.0649 12.5709 15.913L10.9413 14.2834C10.6478 13.9899 10.6478 13.504 10.9413 13.2105C11.2349 12.917 11.7207 12.917 12.0143 13.2105L13.1074 14.3037L16.9234 10.4877C17.2169 10.1942 17.7027 10.1942 17.9963 10.4877C18.2898 10.7813 18.2898 11.2671 17.9963 11.5607L13.6439 15.913C13.492 16.0649 13.2997 16.1357 13.1074 16.1357Z",
    fill: "url(#paint1_linear_2256_121387)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2256_121387",
    x1: 5,
    y1: 3,
    x2: 24.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2256_121387",
    x1: 10.7212,
    y1: 10.2676,
    x2: 14.9045,
    y2: 20.3631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.7b4f2fc12e6fddd7437856f8b1d800d2.svg";
export { ForwardRef as ReactComponent };